export default {"src":"/_next/static/image/public/assets/feature-images/en/statistics-menu.8f2c04a865f60cd533791258ed1a7860.svg","height":387,"width":318};